import { Text } from '@chakra-ui/react';

import Page from '@inspire/ui/chakra/layout/Page';

import { OnlyForSsoRegistered } from 'components/auth/Redirects';
import Layout from 'components/layout/Layout';
import SignupProfProfileForm from 'components/signup/prof/SignupProfProfileForm';

const InscriptionProfPage = () => (
  <Page title="Mon profil" withPanel headingIsTitle>
    <Text mb={6} textAlign="center">
      INSPIRE vous permet d'accompagner individuellement chacun de vos élèves
      dans leurs choix d'orientation.
    </Text>
    <SignupProfProfileForm />
  </Page>
);

InscriptionProfPage.getWrappers = (page) => (
  <Layout rowVariant="yellow" containerWidth="sm">
    <OnlyForSsoRegistered>{page}</OnlyForSsoRegistered>
  </Layout>
);

export default InscriptionProfPage;
